import { memo, useCallback, useEffect, useState } from "react";
import _ from "lodash";

import { MenuItem } from "components/Menu";
import Text from "components/Text";

import ShareDialog from "entities/Package/components/ShareDialog";

interface IShareWithButton {
  initiallySelectedItemIds: Array<number>;
  additionalOnCloseAction?: () => void;
  onClick?: () => void;
  label?: string;
}

const ShareWithButton = ({
  initiallySelectedItemIds,
  additionalOnCloseAction,
  onClick,
  label = "Share with...",
}: IShareWithButton) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    if (!_.isNil(onClick)) {
      onClick();
    }
    setIsOpen(true);
  }, [onClick]);

  const close = useCallback(() => {
    setIsOpen(false);
    if (!_.isNil(additionalOnCloseAction)) {
      additionalOnCloseAction();
    }
  }, [additionalOnCloseAction]);

  useEffect(() => {
    if (isOpen && !_.isNil(additionalOnCloseAction)) {
      return () => {
        additionalOnCloseAction();
      };
    }
  }, [isOpen, additionalOnCloseAction]);

  return (
    <>
      <MenuItem
        onClick={open}
        dataTestid="share-with-option"
        key="share-with-button"
      >
        <Text variant="text2">{label}</Text>
      </MenuItem>

      {isOpen && (
        <ShareDialog
          open
          handleClose={close}
          initiallySelectedItemIds={initiallySelectedItemIds}
        />
      )}
    </>
  );
};

export default memo(ShareWithButton);
